var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiaolimenu between"},[_c('taolimenulist',{staticClass:"menu",attrs:{"menulist":_vm.tlmenuL}}),_c('recomlayadv',{staticClass:"recomlay"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }